import { initialErrors } from '../Constants/Governorates.constants';
import { Types } from '../Constants/Types';
import GovernorateType from '../Interfaces/governorates.interface';

const GovernoratesReducer = (
  state: GovernorateType['status'] = {
    governorate: undefined,
    governorates: [],
    lgovernorates: false,
    lgovernorate: false,
    ldelete: false,
    error: initialErrors,
    pages: 0,
    total: 0,
  },
  action: GovernorateType['action'],
) => {
  switch (action.type) {
    case Types.FETCH_GOVERNORATES:
      return {
        ...state,
        governorates: action.payload,
        pages: action.pages,
        total: action.total,
      };

    case Types.FETCH_GOVERNORATE:
      return { ...state, governorate: action.payload };

    case Types.START_GOVERNORATES:
      return { ...state, lgovernorates: true };

    case Types.END_GOVERNORATES:
      return { ...state, lgovernorates: false };

    case Types.START_GOVERNORATE:
      return { ...state, lgovernorate: true };

    case Types.END_GOVERNORATE:
      return { ...state, lgovernorate: false };

    case Types.ERROR_GOVERNORATE:
      return {
        ...state,
        error: action?.payload
          ? { ...state.error, [action?.field!]: action.payload }
          : { ...state.error, [action?.field!]: null },
      };

    case Types.RESET_GOVERNORATE:
      return { ...state, error: initialErrors };

    default:
      return state;
  }
};

export default GovernoratesReducer;

